module.exports = __webpack_public_path__ + "static/media/payment.58a809e6.svg";